/**
 * services/localization.js
 * Сервис локализации. Загружает JSON-файлы переводов и предоставляет функцию t().
 *
 * Дизайн: синхронный доступ через предзагруженные JSON-импорты.
 * При необходимости динамической загрузки — заменить на async import().
 */
import en from '@/locales/en.json';
import ar from '@/locales/ar.json';

const locales = { en, ar };

/**
 * Получить перевод по пунктирному ключу.
 * @param {string} language - 'en' | 'ar'
 * @param {string} key      - 'welcome.message'
 * @param {Object} [vars]   - { name: 'John' } → заменяет {{name}}
 * @returns {string}
 */
export function translate(language, key, vars = {}) {
  const dict = locales[language] || locales.en;
  const parts = key.split('.');
  let value = dict;

  for (const part of parts) {
    if (value == null) break;
    value = value[part];
  }

  // Фолбек на английский
  if (value == null) {
    value = parts.reduce((acc, p) => (acc ? acc[p] : null), locales.en);
  }

  if (typeof value !== 'string') {
    console.warn(`[i18n] Missing translation: ${language}.${key}`);
    return key;
  }

  // Подстановка переменных {{varName}}
  return value.replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] ?? `{{${k}}}`);
}

/** Возвращает направление текста для языка */
export function getTextDirection(language) {
  const RTL = new Set(['ar', 'he', 'fa', 'ur']);
  return RTL.has(language) ? 'rtl' : 'ltr';
}

/** Список доступных языков с метаданными */
export const AVAILABLE_LANGUAGES = [
  { code: 'en', label: 'English',  dir: 'ltr', flag: '🇬🇧' },
  { code: 'ar', label: 'العربية',  dir: 'rtl', flag: '🇸🇦' },
];
